export const MOBILEPIVOTS = {
    MANAGEINVENTORY: [
        { label: 'Manage Dashboard', routerLink: '/dashboard' }
    ],
    SINGLEFANDEVICEINVENTORY: [
        { label: 'Manage accounts', routerLink: '/manageInventory' },
        { label: 'Home', routerLink: '/home' }
    ],
    CTNINFO: [
        { label: 'Manage Deployment for all accounts', routerLink: '/manageInventory' },
        { label: 'Manage Dashboard', routerLink: '/dashboard' }
    ],
    SINGLEFANPROFILE: [
        { label: 'Manage Deployment for all accounts', routerLink: '/manageInventory' },
        { label: 'Manage Dashboard', routerLink: '/dashboard' }
    ],
    APPLECERTIFICATE: [
        { label: 'Manage Inventory', routerLink: '/manageInventory' },
        { label: 'Manage Dashboard', routerLink: '/dashboard' }
    ],
    CANCELPARTICIPATION: [
        { label: 'Manage Inventory', routerLink: '/manageInventory' },
        { label: 'Home', routerLink: '/home' }
    ],
    SMSPAGE: [
        { label: 'Home', routerLink: '/home'  }
    ],
    SIGNUPPAGE: [
        { label: 'Back', routerLink: '/manageInventory' },
        { label: 'Manage Dashboard', routerLink: '/dashboard' }
    ],
    ENROLLMENTTOOL: [
        { label: 'Back', routerLink: '/manageInventory' },
        { label: 'Manage Dashboard', routerLink: '/dashboard' }
    ],
    PRODDUCTDETAILSPAGE: [
        { label: 'Home', routerLink: '/home'  }
    ],
};
